import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBiddings } from "../../redux/actions/bidding";
import { fetchSetting } from "../../redux/actions/setting";
import { State } from "../../redux/reducers/root";
import { BIDDING_PRIZE_MODAL } from "../shared/modals/constants";
import { setModal } from "../../redux/actions/modals";
import SupportItem from "../shared/support-item";
import BiddingBudget from "./bidding-budget";
import BiddingHistory from "./bidding-history";
import BiddingPrice from "./bidding-price";
import BiddingRemaining from "./bidding-remaining";
import BiddingStatus from "./bidding-status";
import Loading from "../shared/loading";
import BiddingReport from "./bidding-report";
import BiddingBalanceAlert from "./bidding-balance-alert";

const Bidding = () => {
  document.title = " افزایش بازدید - پنل دستیار پزشک خوب";

  const dispatch = useDispatch();

  const doctor = useSelector((state: State) => state.selectDoctor);
  const fetchData = async () => {
    try {
      doctor?.id && (await dispatch(fetchBiddings(doctor.id)));
    } catch (err: any) {
      err.response.status === 404 && dispatch(setModal({ modal: BIDDING_PRIZE_MODAL, visible: true }));
    }
  };
  const fetchSettingData = async () => {
    await dispatch(fetchSetting());
  };

  useEffect(() => {
    fetchData();
    fetchSettingData();
  }, [doctor.id]);

  const biddingStatus = useSelector((state: State) => state.bidding.status);
  const settingData = useSelector((state: State) => state.setting.data);
  const biddingData = useSelector((state: State) => state.bidding).data;
  const { status, costPerClick, remainingClicks, balance } = biddingData;
  const [max, min] = [
    settingData &&
      Array.isArray(settingData) &&
      settingData.find((item) => item?.key === "sapi_bidding_backend_coefficient_maximum")?.value,
    settingData &&
      Array.isArray(settingData) &&
      settingData.find((item) => item?.key === "sapi_bidding_backend_coefficient_minimum")?.value,
  ];

  if (biddingStatus === "LOADING") return <Loading />;

  return (
    <>
      {status !== undefined && doctor.id && costPerClick && (
        <div className="flex flex-col mx-3 ">
          <div className="mt-4 text-base font-bold ">
            <p>افزایش بازدید</p>
          </div>
          <BiddingStatus doctorId={doctor.id} costPerClick={costPerClick} status={status} balance={balance!} />
          <BiddingBalanceAlert balance={balance!} status={status} />
          <BiddingPrice
            doctorId={doctor.id}
            costPerClick={costPerClick}
            status={status}
            max={Number(max)!}
            min={Number(min)!}
          />
          <BiddingBudget doctorId={doctor.id} balance={balance!} status={status} />
          <BiddingRemaining remainingClicks={remainingClicks!} />
          <BiddingHistory
            doctorId={doctor.id}
            title="بازدید 30 روز گذشته"
            color="clear-blue"
            icon="fa fa-eye"
            className="grid items-center h-20"
            link={`/doctors/${doctor.id}/reports`}
          />
          <div className="px-3 py-4 mt-4 text-sm bg-white rounded-md shadow">
            <p className="mb-4 font-bold">مزایای استفاده از بسته افزایش بازدید</p>
            <p className="text-justify">
              عدد مشخص شده در قسمت «قیمت هر بازدید»، مبلغی است که به ازای هر بازدید از بودجه شما کسر خواهد شد و هرچه این
              عدد بالاتر باشد، صفحه شما با احتمال بیشتری در جستجوی سایت نمایش داده می‌شود.
              <br />
              <br /> بازخورد دریافت شده از طریق این طرح، در هزینه تمدید شما لحاظ نشده و منجر به کاهش آن ‌می‌شود. همچنین
              بودجه تعریف شده صرفا در این قسمت مصرف می‌شود.
            </p>
          </div>
          <div className="mt-4 font-bold ">
            <SupportItem
              title="پشتیبانی تلفنی"
              color="primary"
              icon="far fa-phone fa-lg"
              description="09036616777"
              link="tel:09036616777"
              className="grid items-center h-20"
            />
          </div>
          <BiddingReport doctorId={doctor.id} />
        </div>
      )}
    </>
  );
};

export default Bidding;
